module.exports = __webpack_public_path__ + "img/cong.17a611b6.png";